import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Zipped Files Icon
 *
 * @file ZippedFiles.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const ZippedFiles = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1C6.62951 1 7.22229 1.29639 7.6 1.8L8.5
        3H15C16.1046 3 17 3.89543 17 5V16C17 16.5523
        16.5523 17 16 17H2C1.44772 17 1 16.5523 1 16V3C1
        1.89543 1.89543 1 3 1H6ZM6 2.75H3C2.86193 2.75
        2.75 2.86193 2.75 3V15.25H15.25V5C15.25 4.86193
        15.1381 4.75 15 4.75H7.625L6.2 2.85C6.15279
        2.78705 6.07869 2.75 6 2.75ZM9 6C9.55229 6 10
        6.44772 10 7V9H12C12.5523 9 13 9.44771 13 10C13
        10.5523 12.5523 11 12 11H10V13C10 13.5523 9.55229
        14 9 14C8.44772 14 8 13.5523 8 13V11H6C5.44772
        11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9H8V7C8
        6.44772 8.44772 6 9 6Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default ZippedFiles;
